import React, { Component } from 'react';

import Header from './header';
import Home from '../routes/home';
import Footer from './Footer';

if (module.hot) {
  require('preact/debug'); // eslint-disable-line
}

export default class App extends Component {
  render() {
    return (
      <div id="app">
        <Header />
        <Home />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js